import type { ReactNode } from 'react';

/**
 * On or off, for a thing that is either — a feature, a setting with two
 * answers. It replaces the on/off/trial dropdown only where there are two
 * answers; a third keeps its control.
 *
 * A real checkbox underneath with `role="switch"`, so a screen reader says
 * "switch, on" and the keyboard behaves the way every browser already makes a
 * checkbox behave. The visible track is decoration drawn by `kit.css`; the
 * label is required because a switch with nothing beside it names nothing.
 *
 * The change is **reported**, not applied: the caller decides whether turning
 * something off asks first (principle 5 — "turning a feature off confirms").
 */
export function Switch({
  checked,
  label,
  disabled = false,
  onChange,
}: {
  checked: boolean;
  label: string;
  disabled?: boolean;
  onChange: (next: boolean) => void;
}): ReactNode {
  return (
    <label className="switch">
      <input
        type="checkbox"
        role="switch"
        aria-label={label}
        aria-checked={checked}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span aria-hidden="true" />
    </label>
  );
}
